import React from 'react';
import Nav from '../../components/Nav/Nav';
import NavItem from '../../components/Nav/NavItem';

/**
 * Painel de navegação
 * @param show Define se a navegação é exibida
 * @returns
 */
export function Navigation(props) {
  if (!props.show) { return <></>; }
  return (
    <div className="subHeader">
      {props.breadcrumbs}
      <Nav>
        {/* <NavItem to="/bots/metricas">Métricas</NavItem> */}
        <NavItem to="/bots/fluxos-conversa">Fluxo da Conversa</NavItem>
        <NavItem to="/bots/testes">Testes</NavItem>
        <NavItem to="/bots/knowledgebases">Bases de Conhecimento</NavItem>
      </Nav>
    </div>
  );
}

export default Navigation;
